/* RESPONSIBLE TEAM: team-ai-agent */
import type IntlService from 'ember-intl/services/intl';
import {
  and,
  funnelSeries,
} from 'embercom/components/reporting/bespoke/sdr-performance/qualification-funnel/series-config';

type RoutingOutcome = {
  identifier: string;
  title: string;
};

const filters = {
  get sdrParticipated() {
    return {
      type: 'category',
      data: {
        property: 'fin_sdr.participated',
        attribute: 'conversation.fin_sdr.participated',
        values: [true],
      },
    };
  },

  routingOutcome(outcomeTitle: string) {
    return {
      type: 'category',
      data: {
        property: 'fin_sdr.routing_outcome.title',
        attribute: 'conversation.fin_sdr.routing_outcome_title',
        values: [outcomeTitle],
      },
    };
  },
};

export const QualificationRatesConfig = {
  getChartSeries(intl: IntlService, outcome: RoutingOutcome) {
    return [
      funnelSeries(
        and(filters.sdrParticipated, filters.routingOutcome(outcome.title)),
        intl.t('ai-agent.analyze.leads.outcome-rate', { outcome: outcome.title }),
      ),
      funnelSeries(
        filters.sdrParticipated,
        intl.t('ai-agent.analyze.leads.prospects-count', { outcome: outcome.title }),
      ),
    ];
  },
};
